import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import ReservationList from './components/ReservationList';

const { Cell } = ResponsiveGrid;

const CarServiceArrangement = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="叫車服務預約及安排"
        breadcrumbs={[
          {
            name: '叫車服務管理',
          },
          {
            name: '叫車服務預約及安排',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <ReservationList />
    </Cell>
  </ResponsiveGrid>
);

export default CarServiceArrangement;
